<!--
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-ly-tab-page">
    <template v-if="tabContentList?.length">
      <div v-for="(item, index) in tabContentList" :key="item.id" style="height: 100%">
        <div :class="['tab-group', index == tabContentList.length - 1 ? 'tab-group-last' : '']" v-if="item.modules?.length && isShowGroup(item?.modules)">
          <h3 :class="['tab-group-title', index != 0 ? 'tab-group-title-line' : '']" @click="switchfold(item)">
            <div :class="['tab-group-title-content', !item.isfold ? 'tab-group-title-content-isfold' : '']">
              <qfei-icon-caret-down-outlined v-show="item.isfold" class="icondown icondown-isfold" />

              <qfei-icon-caret-right-outlined v-show="!item.isfold" class="icondown" />
              <div class="line" v-show="item.isfold"><span></span></div>

              <p class="tab-group-title-text">
                <span class="tab-group-title-text-span">{{ item.label || t('分组') }}</span>
              </p>
            </div>
          </h3>
          <div class="tab-group-content" v-show="item.isfold">
            <template v-if="item.modules?.length">
              <fh-fields @cb="customerCb" :record="item.modules"></fh-fields>
            </template>
            <jw-empty class="empty-height" v-else :img-src="imgSvg"></jw-empty>
          </div>
        </div>
      </div>
    </template>
    <jw-empty class="empty-height" v-else :img-src="imgSvg"></jw-empty>
  </div>
</template>

<script setup>
import { computed, inject, onMounted } from 'vue';
import imgSvg from '@/assets/images/img-no-record.svg';
import { QfeiIconCaretRightOutlined } from '@qfei-design/icons-vue';
import fieldPermission from '@/hooks/field-permission';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const { isShowField } = fieldPermission();
import useObjectForm from '@/hooks/object-form';
const { getRecordType } = useObjectForm();
const props = defineProps({
  record: {
    //字段列表
    type: Array,
    default: () => []
  }
});
const ruleFields = inject('detailParams')?.ruleFields;

// 是否有新建按钮
// const getButton = (item) => {
//   var status = false;
//   if (item?.length > 0) {
//     item?.forEach((b) => {
//       b?.modules?.forEach((c) => {
//         if ((data.allowAddObject?.indexOf(c.value) > -1 || b?.businessData >= 200) && userInfo?.roles?.indexOf(c.value) > -1) {
//           status = true;
//         }
//       });
//     });
//   }
//   return status;
// };
const validateShow = (module) => {
  let _isFieldShow = false;
  if (module?.type == 20) {
    _isFieldShow = !!isShowField(module?.setting?.fieldKey, ruleFields.value, module?.display);
  } else if (getRecordType(module?.type)) {
    //查询记录，关联记录
    _isFieldShow = module?.modules?.length && !!isShowField([module?.value, module?.id], ruleFields.value, module?.display);
  } else if (module?.type == 35) {
    _isFieldShow = module?.modules?.length && !!isShowField(module?.value, ruleFields.value, module?.display);
  } else if (module?.type == 60) {
    _isFieldShow = true;
  }

  return _isFieldShow;
};
const isShowGroup = (modules) => {
  let isShow = false;
  modules?.forEach((module) => {
    if (module?.type == 10 && module?.modules?.length) {
      //子分组
      module?.modules?.forEach((mm) => {
        if (validateShow(mm)) {
          isShow = true;
        }
      });
    } else {
      if (validateShow(module)) {
        isShow = true;
      }
    }
  });

  return isShow;
};

const tabContentList = computed(() => props.record);

const switchfold = (item) => {
  item.isfold = !item.isfold;
};

onMounted(() => {
  // 过滤 默认label =“关联对象表格”
  tabContentList.value?.forEach((item) => {
    // 默认展开
    item.isfold = true;
    // if (item?.modules?.length > 0) {
    //   item?.modules?.forEach((sub) => {
    //     if (sub?.type == 30 && sub?.label == '关联对象表格') sub.label = '';
    //   });
    // }
  });
});
const emit = defineEmits(['cb']);
const customerCb = () => {
  emit('cb');
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
